export default __webpack_public_path__ + "static/media/pricing-1.3ef6b069.svg";